import { Link } from "react-router";
import Logo from "./logo";
import NavigationItems from "./navigation-items";

import AccountControls from "../header-phase-1/account-controls";
import SignInHeaderBtn from "@/features/header-phase-1/sign-in-header-btn.tsx";

const Header = () => {
  return (
    <>
      <header>
        <div className="flex justify-between">
          <div className="flex items-center">
            <Link
              className="h-[2.8rem] flex items-center justify-start pr-[3.125rem]"
              to="/"
            >
              <Logo />
            </Link>
            <div className="flex gap-x-[1.25rem] items-center h-full whitespace-nowrap">
              <NavigationItems />
            </div>
          </div>
          <div className="flex justify-center items-center">
            <SignInHeaderBtn />
            <AccountControls />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
